import AxiosConfig from '../config/axios-config'

export default {

  obterAnotacao (ementaId) {
    return AxiosConfig.secureJalekoAPI().get(`/anotacao/ementa/${ementaId}`).then(response => response.data)
  },

  enviarAnotacao (ementaId, anotacao) {
    return AxiosConfig.secureJalekoAPI().post(`/anotacao/ementa/${ementaId}`, { anotacao: anotacao }).then(response => response.data)
  },

  atualizarAnotacao (ementaId, anotacao) {
    return AxiosConfig.secureJalekoAPI().put(`/anotacao/ementa/${ementaId}`, { anotacao: anotacao }).then(response => response.data)
  },

  removerAnotacao (ementaId) {
    return AxiosConfig.secureJalekoAPI().delete(`/anotacao/ementa/${ementaId}`).then(response => response.data)
  }

}
